import { Component, OnInit, Input } from '@angular/core';
import { NgbDateStruct, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../service/common.service';
import { AListModalComponent } from './a-list-modal.component';

export class ListInfo {
    label: string;
    support: string;
    answerlist : any;
    nextquestionlist:any;
    nextflg:boolean;
    addflg:boolean;
    errorflg:boolean;
}

@Component({
    selector: 'list-ttt',
    templateUrl: './a-list.component.html',
})
export class AListComponent implements OnInit {
    @Input() md: ListInfo;
    @Input() listtext:string;
    @Input() main_language_flg:number;
    @Input() ikkatuflg:boolean;

    constructor(
        private commonService: CommonService,
        private modalService: NgbModal,
    ) { }

    ngOnInit() {
    }

    addRow(row:number) : void{
        let sss={
            m_answer_id: null,
            m_answer_content_id: null,
            answer_code: null,
            m_substance_id:null,
            answer_text: "",
            update_datetime: null,
            next_question_list : []
        };
        this.md.answerlist.splice(row+1, 0, sss); // i番目の次に１レコード追加
    }
    delRow(row:number) : void{
        if (this.md.answerlist.length==1){
            this.md.answerlist=[];
            this.addRow(0);
        }else{
            this.md.answerlist.splice(row, 1); // i番目を１レコード削除
        }
    }
    upRow(row:number) : void{
        if (row==0){//最初

        }else{
            this.md.answerlist.splice(row-1, 2, this.md.answerlist[row], this.md.answerlist[row-1]);
        }
    }
    downRow(row:number) : void{
        if (row==this.md.answerlist.length -1){//最終

        }else{
            this.md.answerlist.splice(row, 2, this.md.answerlist[row+1], this.md.answerlist[row]);
        }
    }
    addNext(row:number) : void{
        let sss={
            question_id: null,
            question_text: null,
        };
        this.md.answerlist[row]["next_question_list"].push(sss) //先頭に１レコード追加
    }
    open() : void {
        const modalRef = this.modalService.open(
            AListModalComponent,//対象のComponent
            { backdrop: 'static', keyboard: false }//オプション設定　Esc,背景クリックの時の処理…停止中
        );
        let temp_list_text = "";
        //現在のanswer_lsitの一覧を改行つなぎで
        for(var i in this.md.answerlist){
            if(this.md.answerlist[i]['answer_text']==""){
                //空文字は反映しない
            }else{
                temp_list_text += this.md.answerlist[i]['answer_text'] + '\n';
            }
        }
        modalRef.componentInstance.list_text = temp_list_text;
        modalRef.result.then(
          result => {
              if(result=='Cancel'){
                  //Cancel時の処理
            }else{
                  //OK時の処理
                  //answerlistをクリア
                  this.md.answerlist=[];
                  //改行でsplit
                  let arrxxx = result.split(/\r\n|\r|\n/);
                  for(var i in arrxxx){
                      if(arrxxx[i] == ""){
                        //空文字は反映しない
                      }else{
                        this.md.answerlist.push({
                            "m_answer_id": null,
                            "m_answer_content_id": null,
                            "answer_code": null,
                            "m_substance_id":null,
                            "answer_text": arrxxx[i],
                            "update_datetime": null,
                            "next_question_list": []
                        });
                    }
                }
                  //answerlistに挿入
            }
          }, function () {
            // Esc,背景クリックの時の処理…オプション設定で停止中
            }
        );
      }

    dupcheckList:any=[];
    nextcheckList:any=[];

    checkDuplicate():void{
        this.dupcheckList=[];
        this.nextcheckList=[];

        for(var i in this.md.answerlist){
            if ( this.md.answerlist[i]['next_question_list'].length>0 )
            {
                for(var j in this.md.answerlist[i]['next_question_list']){
                    if( this.md.answerlist[i]['next_question_list'][j]['question_id'] != null ){
                        this.nextcheckList.push( 
                            {
                                question_id:this.md.answerlist[i]['next_question_list'][j]['question_id'],
                                question_text:null
                            }
                        );
                    }
                }
            }
        }
        this.dupcheckList = this.commonService.checkDuplicateRecords(this.nextcheckList,'question_id');
        if(this.dupcheckList.length < this.nextcheckList.length){
            this.md.errorflg = true;
        }else{
            this.md.errorflg = false;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/a0103-question-register/a-list.component.ts